import EnhanceBakeoffTilesPage from "@faire/prototype-playground/workspace/lt/enhance-bakeoff-tiles";
import EnhanceShipCal4Page from "@faire/prototype-playground/workspace/lt/enhance-ship-cal4";
import FocusV2ZoomTilesPage from "@faire/prototype-playground/workspace/lt/focus-v2-zoom-tiles";
import FocusV3ApparelTilesPage from "@faire/prototype-playground/workspace/lt/focus-v3-apparel-tiles";
import FocusV3ClippedTilesPage from "@faire/prototype-playground/workspace/lt/focus-v3-clipped-tiles";
import FocusV3OutpaintTilesPage from "@faire/prototype-playground/workspace/lt/focus-v3-outpaint-tiles";
import FocusXpAllocationPage from "@faire/prototype-playground/workspace/lt/focus-xp-allocation";
import { Route, Switch } from "react-router-dom";

export function LiamToranRoutes() {
  return (
    <Switch>
      <Route
        path="/lt/enhance-bakeoff-tiles"
        component={EnhanceBakeoffTilesPage}
      />
      <Route path="/lt/enhance-ship-cal4" component={EnhanceShipCal4Page} />
      <Route path="/lt/focus-v2-zoom-tiles" component={FocusV2ZoomTilesPage} />
      <Route path="/lt/focus-xp-allocation" component={FocusXpAllocationPage} />
      <Route
        path="/lt/focus-v3-apparel-tiles"
        component={FocusV3ApparelTilesPage}
      />
      <Route
        path="/lt/focus-v3-clipped-tiles"
        component={FocusV3ClippedTilesPage}
      />
      <Route
        path="/lt/focus-v3-outpaint-tiles"
        component={FocusV3OutpaintTilesPage}
      />
    </Switch>
  );
}

export const slug = "lt";
